import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getFornitore } from '../services/api';
import { Container, Card, Button, Row, Col, Spinner, Alert } from 'react-bootstrap';

function FornitoriDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const tornaIndietro = useTornaIndietro('/fornitori');
  const [fornitore, setFornitore] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFornitore = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getFornitore(id);
        setFornitore(response.data);
      } catch (err) {
        setError('Errore nel caricamento del fornitore.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchFornitore();
  }, [id]);


  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Caricamento fornitore...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <Button variant="primary" onClick={tornaIndietro}>Torna alla lista fornitori</Button>
      </Container>
    );
  }

  if (!fornitore) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Fornitore non trovato.</Alert>
        <Button variant="primary" onClick={tornaIndietro}>Torna alla lista fornitori</Button>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h2 className="mb-0">Dettaglio Fornitore: {fornitore.denominazione}</h2>
        </Col>
        <Col xs="auto" className="ms-auto">
          <Button variant="secondary" onClick={tornaIndietro} className="me-2">
            Torna alla Lista
          </Button>
          <Button variant="warning" as={Link} to={`/fornitori/edit/${id}`} className="me-2">
            Modifica
          </Button>
          <Button variant="info" as={Link} to={`/fornitori/print/${id}`}>
            Stampa
          </Button>
        </Col>
      </Row>

      {/* Dati Anagrafici */}
      <Card className="mb-4">
        <Card.Header as="h5">Dati Anagrafici</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>ID:</strong></Col>
                <Col xs={8}>{fornitore.id}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Denominazione:</strong></Col>
                <Col xs={8}>{fornitore.denominazione}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Codice Fiscale:</strong></Col>
                <Col xs={8}>{fornitore.codice_fiscale || 'N/A'}</Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Partita IVA:</strong></Col>
                <Col xs={8}>{isClient ? (fornitore.partita_iva || 'N/A') : null}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Luogo di Nascita:</strong></Col>
                <Col xs={8}>{fornitore.luogo_nascita || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Data di Nascita:</strong></Col>
                <Col xs={8}>{fornitore.data_nascita || 'N/A'}</Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Indirizzo */}
      <Card className="mb-4">
        <Card.Header as="h5">Indirizzo</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Indirizzo:</strong></Col>
                <Col xs={8}>{fornitore.indirizzo || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>CAP:</strong></Col>
                <Col xs={8}>{fornitore.cap || 'N/A'}</Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Città:</strong></Col>
                <Col xs={8}>{fornitore.citta || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Provincia:</strong></Col>
                <Col xs={8}>{fornitore.provincia || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Nazione:</strong></Col>
                <Col xs={8}>{fornitore.nazione || 'N/A'}</Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Contatti */}
      <Card className="mb-4">
        <Card.Header as="h5">Contatti</Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Email:</strong></Col>
                <Col xs={8}>{fornitore.email || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>PEC:</strong></Col>
                <Col xs={8}>{fornitore.pec || 'N/A'}</Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row className="mb-2">
                <Col xs={4}><strong>Telefono:</strong></Col>
                <Col xs={8}>{fornitore.telefono || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Cellulare:</strong></Col>
                <Col xs={8}>{fornitore.cellulare || 'N/A'}</Col>
              </Row>
              <Row className="mb-2">
                <Col xs={4}><strong>Codice Destinatario:</strong></Col>
                <Col xs={8}>{fornitore.codice_destinatario || 'N/A'}</Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default FornitoriDetail;
